module.exports = __webpack_public_path__ + "static/media/website.4e7959de.svg";